import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Channel } from '../../models/channel.interface';

@Component({
  selector: 'app-channel-item',
  templateUrl: './channel-item.component.html',
  styleUrls: ['./channel-item.component.scss']
})
export class ChannelItemComponent {

  @Input() item?: Channel
  @Output() onUpdateChannel = new EventEmitter<Channel>();
  @Output() onDeleteChannel = new EventEmitter<Channel>();


  updateChannel(channel: Channel) {
    this.onUpdateChannel.emit(channel)
  }

  deleteChannel(channel: Channel) { 
    this.onDeleteChannel.emit(channel)
  }

}
